export const locations = {
  'Amazonas': {
    'Chachapoyas': {
      'Chachapoyas': '010101',
      'Asunción': '010102',
      'Balsas': '010103',
      'Cheto': '010104',
      'Chiliquin': '010105',
      'Chuquibamba': '010106',
      'Granada': '010107',
      'Huancas': '010108',
      'La Jalca': '010109',
      'Leimebamba': '010110',
      'Levanto': '010111',
      'Magdalena': '010112',
      'Mariscal Castilla': '010113',
      'Molinopampa': '010114',
      'Montevideo': '010115',
      'Olleros': '010116',
      'Quinjalca': '010117',
      'San Francisco de Daguas': '010118',
      'San Isidro de Maino': '010119',
      'Soloco': '010120',
      'Sonche': '010121',
    },
    'Bagua': {
      'Bagua': '010201',
      'Aramango': '010202',
      'Copallin': '010203',
      'El Parco': '010204',
      'Imaza': '010205',
      'La Peca': '010206',
    },
    'Bongará': {
      'Jumbilla': '010301',
      'Chisquilla': '010302',
      'Churuja': '010303',
      'Corosha': '010304',
      'Cuispes': '010305',
      'Florida': '010306',
      'Jazan': '010307',
      'Recta': '010308',
      'San Carlos': '010309',
      'Shipasbamba': '010310',
      'Valera': '010311',
      'Yambrasbamba': '010312',
    },
    'Condorcanqui': {
      'Nieva': '010401',
      'El Cenepa': '010402',
      'Río Santiago': '010403',
    },
    'Luya': {
      'Lamud': '010501',
      'Camporredondo': '010502',
      'Cocabamba': '010503',
      'Colcamar': '010504',
      'Conila': '010505',
      'Inguilpata': '010506',
      'Longuita': '010507',
      'Lonya Chico': '010508',
      'Luya': '010509',
      'Luya Viejo': '010510',
      'María': '010511',
      'Ocalli': '010512',
      'Ocumal': '010513',
      'Pisuquia': '010514',
      'Providencia': '010515',
      'San Cristóbal': '010516',
      'San Francisco de Yeso': '010517',
      'San Jerónimo': '010518',
      'San Juan de Lopecancha': '010519',
      'Santa Catalina': '010520',
      'Santo Tomas': '010521',
      'Tingo': '010522',
      'Trita': '010523',
    },
    'Rodríguez de Mendoza': {
      'San Nicolás': '010601',
      'Chirimoto': '010602',
      'Cochamal': '010603',
      'Huambo': '010604',
      'Limabamba': '010605',
      'Longar': '010606',
      'Mariscal Benavides': '010607',
      'Milpuc': '010608',
      'Omia': '010609',
      'Santa Rosa': '010610',
      'Totora': '010611',
      'Vista Alegre': '010612',
    },
    'Utcubamba': {
      'Bagua Grande': '010701',
      'Cajaruro': '010702',
      'Cumba': '010703',
      'El Milagro': '010704',
      'Jamalca': '010705',
      'Lonya Grande': '010706',
      'Yamon': '010707',
    },
  },
  'Áncash': {
    'Huaraz': {
      'Huaraz': '020101',
      'Cochabamba': '020102',
      'Colcabamba': '020103',
      'Huanchay': '020104',
      'Independencia': '020105',
      'Jangas': '020106',
      'La Libertad': '020107',
      'Olleros': '020108',
      'Pampas Grande': '020109',
      'Pariacoto': '020110',
      'Pira': '020111',
      'Tarica': '020112',
    },
    'Aija': {
      'Aija': '020201',
      'Coris': '020202',
      'Huacllan': '020203',
      'La Merced': '020204',
      'Succha': '020205',
    },
    'Antonio Raymondi': {
      'Llamellin': '020301',
      'Aczo': '020302',
      'Chaccho': '020303',
      'Chingas': '020304',
      'Mirgas': '020305',
      'San Juan de Rontoy': '020306',
    },
    'Asunción': { Chacas: '020401', Acochaca: '020402' },
    'Bolognesi': {
      'Chiquian': '020501',
      'Abelardo Pardo Lezameta': '020502',
      'Antonio Raymondi': '020503',
      'Aquia': '020504',
      'Cajacay': '020505',
      'Canis': '020506',
      'Colquioc': '020507',
      'Huallanca': '020508',
      'Huasta': '020509',
      'Huayllacayan': '020510',
      'La Primavera': '020511',
      'Mangas': '020512',
      'Pacllon': '020513',
      'San Miguel de Corpanqui': '020514',
      'Ticllos': '020515',
    },
    'Carhuaz': {
      'Carhuaz': '020601',
      'Acopampa': '020602',
      'Amashca': '020603',
      'Anta': '020604',
      'Ataquero': '020605',
      'Marcara': '020606',
      'Pariahuanca': '020607',
      'San Miguel de Aco': '020608',
      'Shilla': '020609',
      'Tinco': '020610',
      'Yungar': '020611',
    },
    'Carlos Fermín Fitzcarrald': {
      'San Luis': '020701',
      'San Nicolás': '020702',
      'Yauya': '020703',
    },
    'Casma': {
      'Casma': '020801',
      'Buena Vista Alta': '020802',
      'Comandante Noel': '020803',
      'Yautan': '020804',
    },
    'Corongo': {
      'Corongo': '020901',
      'Aco': '020902',
      'Bambas': '020903',
      'Cusca': '020904',
      'La Pampa': '020905',
      'Yanac': '020906',
      'Yupan': '020907',
    },
    'Huari': {
      'Huari': '021001',
      'Anra': '021002',
      'Cajay': '021003',
      'Chavin de Huantar': '021004',
      'Huacachi': '021005',
      'Huacchis': '021006',
      'Huachis': '021007',
      'Huantar': '021008',
      'Masin': '021009',
      'Paucas': '021010',
      'Ponto': '021011',
      'Rahuapampa': '021012',
      'Rapayan': '021013',
      'San Marcos': '021014',
      'San Pedro de Chana': '021015',
      'Uco': '021016',
    },
    'Huarmey': {
      Huarmey: '021101',
      Cochapeti: '021102',
      Culebras: '021103',
      Huayan: '021104',
      Malvas: '021105',
    },
    'Huaylas': {
      'Caraz': '021201',
      'Huallanca': '021202',
      'Huata': '021203',
      'Huaylas': '021204',
      'Mato': '021205',
      'Pamparomas': '021206',
      'Pueblo Libre': '021207',
      'Santa Cruz': '021208',
      'Santo Toribio': '021209',
      'Yuracmarca': '021210',
    },
    'Mariscal Luzuriaga': {
      'Piscobamba': '021301',
      'Casca': '021302',
      'Eleazar Guzmán Barron': '021303',
      'Fidel Olivas Escudero': '021304',
      'Llama': '021305',
      'Llumpa': '021306',
      'Lucma': '021307',
      'Musga': '021308',
    },
    'Ocros': {
      'Ocros': '021401',
      'Acas': '021402',
      'Cajamarquilla': '021403',
      'Carhuapampa': '021404',
      'Cochas': '021405',
      'Congas': '021406',
      'Llipa': '021407',
      'San Cristóbal de Rajan': '021408',
      'San Pedro': '021409',
      'Santiago de Chilcas': '021410',
    },
    'Pallasca': {
      'Cabana': '021501',
      'Bolognesi': '021502',
      'Conchucos': '021503',
      'Huacaschuque': '021504',
      'Huandoval': '021505',
      'Lacabamba': '021506',
      'Llapo': '021507',
      'Pallasca': '021508',
      'Pampas': '021509',
      'Santa Rosa': '021510',
      'Tauca': '021511',
    },
    'Pomabamba': {
      Pomabamba: '021601',
      Huayllan: '021602',
      Parobamba: '021603',
      Quinuabamba: '021604',
    },
    'Recuay': {
      'Recuay': '021701',
      'Catac': '021702',
      'Cotaparaco': '021703',
      'Huayllapampa': '021704',
      'Llacllin': '021705',
      'Marca': '021706',
      'Pampas Chico': '021707',
      'Pararin': '021708',
      'Tapacocha': '021709',
      'Ticapampa': '021710',
    },
    'Santa': {
      'Chimbote': '021801',
      'Cáceres del Perú': '021802',
      'Coishco': '021803',
      'Macate': '021804',
      'Moro': '021805',
      'Nepeña': '021806',
      'Samanco': '021807',
      'Santa': '021808',
      'Nuevo Chimbote': '021809',
    },
    'Sihuas': {
      'Sihuas': '021901',
      'Acobamba': '021902',
      'Alfonso Ugarte': '021903',
      'Cashapampa': '021904',
      'Chingalpo': '021905',
      'Huayllabamba': '021906',
      'Quiches': '021907',
      'Ragash': '021908',
      'San Juan': '021909',
      'Sicsibamba': '021910',
    },
    'Yungay': {
      Yungay: '022001',
      Cascapara: '022002',
      Mancos: '022003',
      Matacoto: '022004',
      Quillo: '022005',
      Ranrahirca: '022006',
      Shupluy: '022007',
      Yanama: '022008',
    },
  },
  'Apurímac': {
    Abancay: {
      'Abancay': '030101',
      'Chacoche': '030102',
      'Circa': '030103',
      'Curahuasi': '030104',
      'Huanipaca': '030105',
      'Lambrama': '030106',
      'Pichirhua': '030107',
      'San Pedro de Cachora': '030108',
      'Tamburco': '030109',
    },
    Andahuaylas: {
      'Andahuaylas': '030201',
      'Andarapa': '030202',
      'Chiara': '030203',
      'Huancarama': '030204',
      'Huancaray': '030205',
      'Huayana': '030206',
      'Kishuara': '030207',
      'Pacobamba': '030208',
      'Pacucha': '030209',
      'Pampachiri': '030210',
      'Pomacocha': '030211',
      'San Antonio de Cachi': '030212',
      'San Jerónimo': '030213',
      'San Miguel de Chaccrampa': '030214',
      'Santa María de Chicmo': '030215',
      'Talavera': '030216',
      'Tumay Huaraca': '030217',
      'Turpo': '030218',
      'Kaquiabamba': '030219',
      'José María Arguedas': '030220',
    },
    Antabamba: {
      'Antabamba': '030301',
      'El Oro': '030302',
      'Huaquirca': '030303',
      'Juan Espinoza Medrano': '030304',
      'Oropesa': '030305',
      'Pachaconas': '030306',
      'Sabaino': '030307',
    },
    Aymaraes: {
      'Chalhuanca': '030401',
      'Capaya': '030402',
      'Caraybamba': '030403',
      'Chapimarca': '030404',
      'Colcabamba': '030405',
      'Cotaruse': '030406',
      'Ihuayllo': '030407',
      'Justo Apu Sahuaraura': '030408',
      'Lucre': '030409',
      'Pocohuanca': '030410',
      'San Juan de Chacña': '030411',
      'Sañayca': '030412',
      'Soraya': '030413',
      'Tapairihua': '030414',
      'Tintay': '030415',
      'Toraya': '030416',
      'Yanaca': '030417',
    },
    Cotabambas: {
      Tambobamba: '030501',
      Cotabambas: '030502',
      Coyllurqui: '030503',
      Haquira: '030504',
      Mara: '030505',
      Challhuahuacho: '030506',
    },
    Chincheros: {
      'Chincheros': '030601',
      'Anco_Huallo': '030602',
      'Cocharcas': '030603',
      'Huaccana': '030604',
      'Ocobamba': '030605',
      'Ongoy': '030606',
      'Uranmarca': '030607',
      'Ranracancha': '030608',
      'Rocchacc': '030609',
      'El Porvenir': '030610',
      'Los Chankas': '030611',
    },
    Grau: {
      'Chuquibambilla': '030701',
      'Curpahuasi': '030702',
      'Gamarra': '030703',
      'Huayllati': '030704',
      'Mamara': '030705',
      'Micaela Bastidas': '030706',
      'Pataypampa': '030707',
      'Progreso': '030708',
      'San Antonio': '030709',
      'Santa Rosa': '030710',
      'Turpay': '030711',
      'Vilcabamba': '030712',
      'Virundo': '030713',
      'Curasco': '030714',
    },
  },
  'Arequipa': {
    'Arequipa': {
      'Arequipa': '040101',
      'Alto Selva Alegre': '040102',
      'Cayma': '040103',
      'Cerro Colorado': '040104',
      'Characato': '040105',
      'Chiguata': '040106',
      'Jacobo Hunter': '040107',
      'La Joya': '040108',
      'Mariano Melgar': '040109',
      'Miraflores': '040110',
      'Mollebaya': '040111',
      'Paucarpata': '040112',
      'Pocsi': '040113',
      'Polobaya': '040114',
      'Quequeña': '040115',
      'Sabandia': '040116',
      'Sachaca': '040117',
      'San Juan de Siguas': '040118',
      'San Juan de Tarucani': '040119',
      'Santa Isabel de Siguas': '040120',
      'Santa Rita de Siguas': '040121',
      'Socabaya': '040122',
      'Tiabaya': '040123',
      'Uchumayo': '040124',
      'Vitor': '040125',
      'Yanahuara': '040126',
      'Yarabamba': '040127',
      'Yura': '040128',
      'José Luis Bustamante Y Rivero': '040129',
    },
    'Camaná': {
      'Camaná': '040201',
      'José María Quimper': '040202',
      'Mariano Nicolás Valcárcel': '040203',
      'Mariscal Cáceres': '040204',
      'Nicolás de Pierola': '040205',
      'Ocoña': '040206',
      'Quilca': '040207',
      'Samuel Pastor': '040208',
    },
    'Caravelí': {
      'Caravelí': '040301',
      'Acarí': '040302',
      'Atico': '040303',
      'Atiquipa': '040304',
      'Bella Unión': '040305',
      'Cahuacho': '040306',
      'Chala': '040307',
      'Chaparra': '040308',
      'Huanuhuanu': '040309',
      'Jaqui': '040310',
      'Lomas': '040311',
      'Quicacha': '040312',
      'Yauca': '040313',
    },
    'Castilla': {
      Aplao: '040401',
      Andagua: '040402',
      Ayo: '040403',
      Chachas: '040404',
      Chilcaymarca: '040405',
      Choco: '040406',
      Huancarqui: '040407',
      Machaguay: '040408',
      Orcopampa: '040409',
      Pampacolca: '040410',
      Tipan: '040411',
      Uñon: '040412',
      Uraca: '040413',
      Viraco: '040414',
    },
    'Caylloma': {
      'Chivay': '040501',
      'Achoma': '040502',
      'Cabanaconde': '040503',
      'Callalli': '040504',
      'Caylloma': '040505',
      'Coporaque': '040506',
      'Huambo': '040507',
      'Huanca': '040508',
      'Ichupampa': '040509',
      'Lari': '040510',
      'Lluta': '040511',
      'Maca': '040512',
      'Madrigal': '040513',
      'San Antonio de Chuca': '040514',
      'Sibayo': '040515',
      'Tapay': '040516',
      'Tisco': '040517',
      'Tuti': '040518',
      'Yanque': '040519',
      'Majes': '040520',
    },
    'Condesuyos': {
      'Chuquibamba': '040601',
      'Andaray': '040602',
      'Cayarani': '040603',
      'Chichas': '040604',
      'Iray': '040605',
      'Río Grande': '040606',
      'Salamanca': '040607',
      'Yanaquihua': '040608',
    },
    'Islay': {
      'Mollendo': '040701',
      'Cocachacra': '040702',
      'Dean Valdivia': '040703',
      'Islay': '040704',
      'Mejia': '040705',
      'Punta de Bombón': '040706',
    },
    'La Uniòn': {
      Cotahuasi: '040801',
      Alca: '040802',
      Charcana: '040803',
      Huaynacotas: '040804',
      Pampamarca: '040805',
      Puyca: '040806',
      Quechualla: '040807',
      Sayla: '040808',
      Tauria: '040809',
      Tomepampa: '040810',
      Toro: '040811',
    },
  },
  'Ayacucho': {
    'Huamanga': {
      'Ayacucho': '050101',
      'Acocro': '050102',
      'Acos Vinchos': '050103',
      'Carmen Alto': '050104',
      'Chiara': '050105',
      'Ocros': '050106',
      'Pacaycasa': '050107',
      'Quinua': '050108',
      'San José de Ticllas': '050109',
      'San Juan Bautista': '050110',
      'Santiago de Pischa': '050111',
      'Socos': '050112',
      'Tambillo': '050113',
      'Vinchos': '050114',
      'Jesús Nazareno': '050115',
      'Andrés Avelino Cáceres Dorregaray': '050116',
    },
    'Cangallo': {
      'Cangallo': '050201',
      'Chuschi': '050202',
      'Los Morochucos': '050203',
      'María Parado de Bellido': '050204',
      'Paras': '050205',
      'Totos': '050206',
    },
    'Huanca Sancos': {
      'Sancos': '050301',
      'Carapo': '050302',
      'Sacsamarca': '050303',
      'Santiago de Lucanamarca': '050304',
    },
    'Huanta': {
      Huanta: '050401',
      Ayahuanco: '050402',
      Huamanguilla: '050403',
      Iguain: '050404',
      Luricocha: '050405',
      Santillana: '050406',
      Sivia: '050407',
      Llochegua: '050408',
      Canayre: '050409',
      Uchuraccay: '050410',
      Pucacolpa: '050411',
      Chaca: '050412',
    },
    'La Mar': {
      'San Miguel': '050501',
      'Anco': '050502',
      'Ayna': '050503',
      'Chilcas': '050504',
      'Chungui': '050505',
      'Luis Carranza': '050506',
      'Santa Rosa': '050507',
      'Tambo': '050508',
      'Samugari': '050509',
      'Anchihuay': '050510',
      'Oronccoy': '050511',
    },
    'Lucanas': {
      'Puquio': '050601',
      'Aucara': '050602',
      'Cabana': '050603',
      'Carmen Salcedo': '050604',
      'Chaviña': '050605',
      'Chipao': '050606',
      'Huac-Huas': '050607',
      'Laramate': '050608',
      'Leoncio Prado': '050609',
      'Llauta': '050610',
      'Lucanas': '050611',
      'Ocaña': '050612',
      'Otoca': '050613',
      'Saisa': '050614',
      'San Cristóbal': '050615',
      'San Juan': '050616',
      'San Pedro': '050617',
      'San Pedro de Palco': '050618',
      'Sancos': '050619',
      'Santa Ana de Huaycahuacho': '050620',
      'Santa Lucia': '050621',
    },
    'Parinacochas': {
      'Coracora': '050701',
      'Chumpi': '050702',
      'Coronel Castañeda': '050703',
      'Pacapausa': '050704',
      'Pullo': '050705',
      'Puyusca': '050706',
      'San Francisco de Ravacayco': '050707',
      'Upahuacho': '050708',
    },
    'Pàucar del Sara Sara': {
      'Pausa': '050801',
      'Colta': '050802',
      'Corculla': '050803',
      'Lampa': '050804',
      'Marcabamba': '050805',
      'Oyolo': '050806',
      'Pararca': '050807',
      'San Javier de Alpabamba': '050808',
      'San José de Ushua': '050809',
      'Sara Sara': '050810',
    },
    'Sucre': {
      'Querobamba': '050901',
      'Belén': '050902',
      'Chalcos': '050903',
      'Chilcayoc': '050904',
      'Huacaña': '050905',
      'Morcolla': '050906',
      'Paico': '050907',
      'San Pedro de Larcay': '050908',
      'San Salvador de Quije': '050909',
      'Santiago de Paucaray': '050910',
      'Soras': '050911',
    },
    'Víctor Fajardo': {
      Huancapi: '051001',
      Alcamenca: '051002',
      Apongo: '051003',
      Asquipata: '051004',
      Canaria: '051005',
      Cayara: '051006',
      Colca: '051007',
      Huamanquiquia: '051008',
      Huancaraylla: '051009',
      Hualla: '051010',
      Sarhua: '051011',
      Vilcanchos: '051012',
    },
    'Vilcas Huamán': {
      'Vilcas Huaman': '051101',
      'Accomarca': '051102',
      'Carhuanca': '051103',
      'Concepción': '051104',
      'Huambalpa': '051105',
      'Independencia': '051106',
      'Saurama': '051107',
      'Vischongo': '051108',
    },
  },
  'Cajamarca': {
    'Cajamarca': {
      'Cajamarca': '060101',
      'Asunción': '060102',
      'Chetilla': '060103',
      'Cospan': '060104',
      'Encañada': '060105',
      'Jesús': '060106',
      'Llacanora': '060107',
      'Los Baños del Inca': '060108',
      'Magdalena': '060109',
      'Matara': '060110',
      'Namora': '060111',
      'San Juan': '060112',
    },
    'Cajabamba': {
      Cajabamba: '060201',
      Cachachi: '060202',
      Condebamba: '060203',
      Sitacocha: '060204',
    },
    'Celendín': {
      'Celendín': '060301',
      'Chumuch': '060302',
      'Cortegana': '060303',
      'Huasmin': '060304',
      'Jorge Chávez': '060305',
      'José Gálvez': '060306',
      'Miguel Iglesias': '060307',
      'Oxamarca': '060308',
      'Sorochuco': '060309',
      'Sucre': '060310',
      'Utco': '060311',
      'La Libertad de Pallan': '060312',
    },
    'Chota': {
      'Chota': '060401',
      'Anguia': '060402',
      'Chadin': '060403',
      'Chiguirip': '060404',
      'Chimban': '060405',
      'Choropampa': '060406',
      'Cochabamba': '060407',
      'Conchan': '060408',
      'Huambos': '060409',
      'Lajas': '060410',
      'Llama': '060411',
      'Miracosta': '060412',
      'Paccha': '060413',
      'Pion': '060414',
      'Querocoto': '060415',
      'San Juan de Licupis': '060416',
      'Tacabamba': '060417',
      'Tocmoche': '060418',
      'Chalamarca': '060419',
    },
    'Contumazá': {
      'Contumaza': '060501',
      'Chilete': '060502',
      'Cupisnique': '060503',
      'Guzmango': '060504',
      'San Benito': '060505',
      'Santa Cruz de Toledo': '060506',
      'Tantarica': '060507',
      'Yonan': '060508',
    },
    'Cutervo': {
      'Cutervo': '060601',
      'Callayuc': '060602',
      'Choros': '060603',
      'Cujillo': '060604',
      'La Ramada': '060605',
      'Pimpingos': '060606',
      'Querocotillo': '060607',
      'San Andrés de Cutervo': '060608',
      'San Juan de Cutervo': '060609',
      'San Luis de Lucma': '060610',
      'Santa Cruz': '060611',
      'Santo Domingo de la Capilla': '060612',
      'Santo Tomas': '060613',
      'Socota': '060614',
      'Toribio Casanova': '060615',
    },
    'Hualgayoc': {
      Bambamarca: '060701',
      Chugur: '060702',
      Hualgayoc: '060703',
    },
    'Jaén': {
      'Jaén': '060801',
      'Bellavista': '060802',
      'Chontali': '060803',
      'Colasay': '060804',
      'Huabal': '060805',
      'Las Pirias': '060806',
      'Pomahuaca': '060807',
      'Pucara': '060808',
      'Sallique': '060809',
      'San Felipe': '060810',
      'San José del Alto': '060811',
      'Santa Rosa': '060812',
    },
    'San Ignacio': {
      'San Ignacio': '060901',
      'Chirinos': '060902',
      'Huarango': '060903',
      'La Coipa': '060904',
      'Namballe': '060905',
      'San José de Lourdes': '060906',
      'Tabaconas': '060907',
    },
    'San Marcos': {
      'Pedro Gálvez': '061001',
      'Chancay': '061002',
      'Eduardo Villanueva': '061003',
      'Gregorio Pita': '061004',
      'Ichocan': '061005',
      'José Manuel Quiroz': '061006',
      'José Sabogal': '061007',
    },
    'San Miguel': {
      'San Miguel': '061101',
      'Bolívar': '061102',
      'Calquis': '061103',
      'Catilluc': '061104',
      'El Prado': '061105',
      'La Florida': '061106',
      'Llapa': '061107',
      'Nanchoc': '061108',
      'Niepos': '061109',
      'San Gregorio': '061110',
      'San Silvestre de Cochan': '061111',
      'Tongod': '061112',
      'Unión Agua Blanca': '061113',
    },
    'San Pablo': {
      'San Pablo': '061201',
      'San Bernardino': '061202',
      'San Luis': '061203',
      'Tumbaden': '061204',
    },
    'Santa Cruz': {
      'Santa Cruz': '061301',
      'Andabamba': '061302',
      'Catache': '061303',
      'Chancaybaños': '061304',
      'La Esperanza': '061305',
      'Ninabamba': '061306',
      'Pulan': '061307',
      'Saucepampa': '061308',
      'Sexi': '061309',
      'Uticyacu': '061310',
      'Yauyucan': '061311',
    },
  },
  'Callao': {
    Callao: {
      'Callao': '070101',
      'Bellavista': '070102',
      'Carmen de la Legua Reynoso': '070103',
      'La Perla': '070104',
      'La Punta': '070105',
      'Ventanilla': '070106',
      'Mi Perú': '070107',
    },
  },
  'Cusco': {
    'Cusco': {
      'Cusco': '080101',
      'Ccorca': '080102',
      'Poroy': '080103',
      'San Jerónimo': '080104',
      'San Sebastian': '080105',
      'Santiago': '080106',
      'Saylla': '080107',
      'Wanchaq': '080108',
    },
    'Acomayo': {
      'Acomayo': '080201',
      'Acopia': '080202',
      'Acos': '080203',
      'Mosoc Llacta': '080204',
      'Pomacanchi': '080205',
      'Rondocan': '080206',
      'Sangarara': '080207',
    },
    'Anta': {
      Anta: '080301',
      Ancahuasi: '080302',
      Cachimayo: '080303',
      Chinchaypujio: '080304',
      Huarocondo: '080305',
      Limatambo: '080306',
      Mollepata: '080307',
      Pucyura: '080308',
      Zurite: '080309',
    },
    'Calca': {
      'Calca': '080401',
      'Coya': '080402',
      'Lamay': '080403',
      'Lares': '080404',
      'Pisac': '080405',
      'San Salvador': '080406',
      'Taray': '080407',
      'Yanatile': '080408',
    },
    'Canas': {
      'Yanaoca': '080501',
      'Checca': '080502',
      'Kunturkanki': '080503',
      'Langui': '080504',
      'Layo': '080505',
      'Pampamarca': '080506',
      'Quehue': '080507',
      'Tupac Amaru': '080508',
    },
    'Canchis': {
      'Sicuani': '080601',
      'Checacupe': '080602',
      'Combapata': '080603',
      'Marangani': '080604',
      'Pitumarca': '080605',
      'San Pablo': '080606',
      'San Pedro': '080607',
      'Tinta': '080608',
    },
    'Chumbivilcas': {
      'Santo Tomas': '080701',
      'Capacmarca': '080702',
      'Chamaca': '080703',
      'Colquemarca': '080704',
      'Livitaca': '080705',
      'Llusco': '080706',
      'Quiñota': '080707',
      'Velille': '080708',
    },
    'Espinar': {
      'Espinar': '080801',
      'Condoroma': '080802',
      'Coporaque': '080803',
      'Ocoruro': '080804',
      'Pallpata': '080805',
      'Pichigua': '080806',
      'Suyckutambo': '080807',
      'Alto Pichigua': '080808',
    },
    'La Convención': {
      'Santa Ana': '080901',
      'Echarate': '080902',
      'Huayopata': '080903',
      'Maranura': '080904',
      'Ocobamba': '080905',
      'Quellouno': '080906',
      'Kimbiri': '080907',
      'Santa Teresa': '080908',
      'Vilcabamba': '080909',
      'Pichari': '080910',
      'Inkawasi': '080911',
      'Villa Virgen': '080912',
      'Villa Kintiarina': '080913',
      'Megantoni': '080914',
    },
    'Paruro': {
      Paruro: '081001',
      Accha: '081002',
      Ccapi: '081003',
      Colcha: '081004',
      Huanoquite: '081005',
      Omachaç: '081006',
      Paccaritambo: '081007',
      Pillpinto: '081008',
      Yaurisque: '081009',
    },
    'Paucartambo': {
      Paucartambo: '081101',
      Caicay: '081102',
      Challabamba: '081103',
      Colquepata: '081104',
      Huancarani: '081105',
      Kosñipata: '081106',
    },
    'Quispicanchi': {
      Urcos: '081201',
      Andahuaylillas: '081202',
      Camanti: '081203',
      Ccarhuayo: '081204',
      Ccatca: '081205',
      Cusipata: '081206',
      Huaro: '081207',
      Lucre: '081208',
      Marcapata: '081209',
      Ocongate: '081210',
      Oropesa: '081211',
      Quiquijana: '081212',
    },
    'Urubamba': {
      Urubamba: '081301',
      Chinchero: '081302',
      Huayllabamba: '081303',
      Machupicchu: '081304',
      Maras: '081305',
      Ollantaytambo: '081306',
      Yucay: '081307',
    },
  },
  'Huancavelica': {
    Huancavelica: {
      'Huancavelica': '090101',
      'Acobambilla': '090102',
      'Acoria': '090103',
      'Conayca': '090104',
      'Cuenca': '090105',
      'Huachocolpa': '090106',
      'Huayllahuara': '090107',
      'Izcuchaca': '090108',
      'Laria': '090109',
      'Manta': '090110',
      'Mariscal Cáceres': '090111',
      'Moya': '090112',
      'Nuevo Occoro': '090113',
      'Palca': '090114',
      'Pilchaca': '090115',
      'Vilca': '090116',
      'Yauli': '090117',
      'Ascensión': '090118',
      'Huando': '090119',
    },
    Acobamba: {
      Acobamba: '090201',
      Andabamba: '090202',
      Anta: '090203',
      Caja: '090204',
      Marcas: '090205',
      Paucara: '090206',
      Pomacocha: '090207',
      Rosario: '090208',
    },
    Angaraes: {
      'Lircay': '090301',
      'Anchonga': '090302',
      'Callanmarca': '090303',
      'Ccochaccasa': '090304',
      'Chincho': '090305',
      'Congalla': '090306',
      'Huanca-Huanca': '090307',
      'Huayllay Grande': '090308',
      'Julcamarca': '090309',
      'San Antonio de Antaparco': '090310',
      'Santo Tomas de Pata': '090311',
      'Secclla': '090312',
    },
    Castrovirreyna: {
      'Castrovirreyna': '090401',
      'Arma': '090402',
      'Aurahua': '090403',
      'Capillas': '090404',
      'Chupamarca': '090405',
      'Cocas': '090406',
      'Huachos': '090407',
      'Huamatambo': '090408',
      'Mollepampa': '090409',
      'San Juan': '090410',
      'Santa Ana': '090411',
      'Tantara': '090412',
      'Ticrapo': '090413',
    },
    Churcampa: {
      'Churcampa': '090501',
      'Anco': '090502',
      'Chinchihuasi': '090503',
      'El Carmen': '090504',
      'La Merced': '090505',
      'Locroja': '090506',
      'Paucarbamba': '090507',
      'San Miguel de Mayocc': '090508',
      'San Pedro de Coris': '090509',
      'Pachamarca': '090510',
      'Cosme': '090511',
    },
    Huaytará: {
      'Huaytara': '090601',
      'Ayavi': '090602',
      'Córdova': '090603',
      'Huayacundo Arma': '090604',
      'Laramarca': '090605',
      'Ocoyo': '090606',
      'Pilpichaca': '090607',
      'Querco': '090608',
      'Quito-Arma': '090609',
      'San Antonio de Cusicancha': '090610',
      'San Francisco de Sangayaico': '090611',
      'San Isidro': '090612',
      'Santiago de Chocorvos': '090613',
      'Santiago de Quirahuara': '090614',
      'Santo Domingo de Capillas': '090615',
      'Tambo': '090616',
    },
    Tayacaja: {
      'Pampas': '090701',
      'Acostambo': '090702',
      'Acraquia': '090703',
      'Ahuaycha': '090704',
      'Colcabamba': '090705',
      'Daniel Hernández': '090706',
      'Huachocolpa': '090707',
      'Huaribamba': '090709',
      'Ñahuimpuquio': '090710',
      'Pazos': '090711',
      'Quishuar': '090713',
      'Salcabamba': '090714',
      'Salcahuasi': '090715',
      'San Marcos de Rocchac': '090716',
      'Surcubamba': '090717',
      'Tintay Puncu': '090718',
      'Quichuas': '090719',
      'Andaymarca': '090720',
      'Roble': '090721',
      'Pichos': '090722',
      'Santiago de Tucuma': '090723',
    },
  },
  'Huánuco': {
    'Huánuco': {
      'Huanuco': '100101',
      'Amarilis': '100102',
      'Chinchao': '100103',
      'Churubamba': '100104',
      'Margos': '100105',
      'Quisqui (Kichki)': '100106',
      'San Francisco de Cayran': '100107',
      'San Pedro de Chaulan': '100108',
      'Santa María del Valle': '100109',
      'Yarumayo': '100110',
      'Pillco Marca': '100111',
      'Yacus': '100112',
      'San Pablo de Pillao': '100113',
    },
    'Ambo': {
      'Ambo': '100201',
      'Cayna': '100202',
      'Colpas': '100203',
      'Conchamarca': '100204',
      'Huacar': '100205',
      'San Francisco': '100206',
      'San Rafael': '100207',
      'Tomay Kichwa': '100208',
    },
    'Dos de Mayo': {
      'La Unión': '100301',
      'Chuquis': '100307',
      'Marías': '100311',
      'Pachas': '100313',
      'Quivilla': '100316',
      'Ripan': '100317',
      'Shunqui': '100321',
      'Sillapata': '100322',
      'Yanas': '100323',
    },
    'Huacaybamba': {
      Huacaybamba: '100401',
      Canchabamba: '100402',
      Cochabamba: '100403',
      Pinra: '100404',
    },
    'Huamalíes': {
      'Llata': '100501',
      'Arancay': '100502',
      'Chavín de Pariarca': '100503',
      'Jacas Grande': '100504',
      'Jircan': '100505',
      'Miraflores': '100506',
      'Monzón': '100507',
      'Punchao': '100508',
      'Puños': '100509',
      'Singa': '100510',
      'Tantamayo': '100511',
    },
    'Leoncio Prado': {
      'Rupa-Rupa': '100601',
      'Daniel Alomía Robles': '100602',
      'Hermílio Valdizan': '100603',
      'José Crespo y Castillo': '100604',
      'Luyando': '100605',
      'Mariano Damaso Beraun': '100606',
      'Pucayacu': '100607',
      'Castillo Grande': '100608',
      'Pueblo Nuevo': '100609',
      'Santo Domingo de Anda': '100610',
    },
    'Marañón': {
      'Huacrachuco': '100701',
      'Cholon': '100702',
      'San Buenaventura': '100703',
      'La Morada': '100704',
      'Santa Rosa de Alto Yanajanca': '100705',
    },
    'Pachitea': {
      Panao: '100801',
      Chaglla: '100802',
      Molino: '100803',
      Umari: '100804',
    },
    'Puerto Inca': {
      'Puerto Inca': '100901',
      'Codo del Pozuzo': '100902',
      'Honoria': '100903',
      'Tournavista': '100904',
      'Yuyapichis': '100905',
    },
    'Lauricocha': {
      'Jesús': '101001',
      'Baños': '101002',
      'Jivia': '101003',
      'Queropalca': '101004',
      'Rondos': '101005',
      'San Francisco de Asís': '101006',
      'San Miguel de Cauri': '101007',
    },
    'Yarowilca': {
      'Chavinillo': '101101',
      'Cahuac': '101102',
      'Chacabamba': '101103',
      'Aparicio Pomares': '101104',
      'Jacas Chico': '101105',
      'Obas': '101106',
      'Pampamarca': '101107',
      'Choras': '101108',
    },
  },
  'Ica': {
    Ica: {
      'Ica': '110101',
      'La Tinguiña': '110102',
      'Los Aquijes': '110103',
      'Ocucaje': '110104',
      'Pachacutec': '110105',
      'Parcona': '110106',
      'Pueblo Nuevo': '110107',
      'Salas': '110108',
      'San José de Los Molinos': '110109',
      'San Juan Bautista': '110110',
      'Santiago': '110111',
      'Subtanjalla': '110112',
      'Tate': '110113',
      'Yauca del Rosario': '110114',
    },
    Chincha: {
      'Chincha Alta': '110201',
      'Alto Laran': '110202',
      'Chavin': '110203',
      'Chincha Baja': '110204',
      'El Carmen': '110205',
      'Grocio Prado': '110206',
      'Pueblo Nuevo': '110207',
      'San Juan de Yanac': '110208',
      'San Pedro de Huacarpana': '110209',
      'Sunampe': '110210',
      'Tambo de Mora': '110211',
    },
    Nasca: {
      'Nasca': '110301',
      'Changuillo': '110302',
      'El Ingenio': '110303',
      'Marcona': '110304',
      'Vista Alegre': '110305',
    },
    Palpa: {
      'Palpa': '110401',
      'Llipata': '110402',
      'Río Grande': '110403',
      'Santa Cruz': '110404',
      'Tibillo': '110405',
    },
    Pisco: {
      'Pisco': '110501',
      'Huancano': '110502',
      'Humay': '110503',
      'Independencia': '110504',
      'Paracas': '110505',
      'San Andrés': '110506',
      'San Clemente': '110507',
      'Tupac Amaru Inca': '110508',
    },
  },
  'Junín': {
    Huancayo: {
      'Huancayo': '120101',
      'Carhuacallanga': '120104',
      'Chacapampa': '120105',
      'Chicche': '120106',
      'Chilca': '120107',
      'Chongos Alto': '120108',
      'Chupuro': '120111',
      'Colca': '120112',
      'Cullhuas': '120113',
      'El Tambo': '120114',
      'Huacrapuquio': '120116',
      'Hualhuas': '120117',
      'Huancan': '120119',
      'Huasicancha': '120120',
      'Huayucachi': '120121',
      'Ingenio': '120122',
      'Pariahuanca': '120124',
      'Pilcomayo': '120125',
      'Pucara': '120126',
      'Quichuay': '120127',
      'Quilcas': '120128',
      'San Agustín': '120129',
      'San Jerónimo de Tunan': '120130',
      'Saño': '120132',
      'Sapallanga': '120133',
      'Sicaya': '120134',
      'Santo Domingo de Acobamba': '120135',
      'Viques': '120136',
    },
    Concepción: {
      'Concepción': '120201',
      'Aco': '120202',
      'Andamarca': '120203',
      'Chambara': '120204',
      'Cochas': '120205',
      'Comas': '120206',
      'Heroínas Toledo': '120207',
      'Manzanares': '120208',
      'Mariscal Castilla': '120209',
      'Matahuasi': '120210',
      'Mito': '120211',
      'Nueve de Julio': '120212',
      'Orcotuna': '120213',
      'San José de Quero': '120214',
      'Santa Rosa de Ocopa': '120215',
    },
    Chanchamayo: {
      'Chanchamayo': '120301',
      'Perene': '120302',
      'Pichanaqui': '120303',
      'San Luis de Shuaro': '120304',
      'San Ramón': '120305',
      'Vitoc': '120306',
    },
    Jauja: {
      'Jauja': '120401',
      'Acolla': '120402',
      'Apata': '120403',
      'Ataura': '120404',
      'Canchayllo': '120405',
      'Curicaca': '120406',
      'El Mantaro': '120407',
      'Huamali': '120408',
      'Huaripampa': '120409',
      'Huertas': '120410',
      'Janjaillo': '120411',
      'Julcán': '120412',
      'Leonor Ordóñez': '120413',
      'Llocllapampa': '120414',
      'Marco': '120415',
      'Masma': '120416',
      'Masma Chicche': '120417',
      'Molinos': '120418',
      'Monobamba': '120419',
      'Muqui': '120420',
      'Muquiyauyo': '120421',
      'Paca': '120422',
      'Paccha': '120423',
      'Pancan': '120424',
      'Parco': '120425',
      'Pomacancha': '120426',
      'Ricran': '120427',
      'San Lorenzo': '120428',
      'San Pedro de Chunan': '120429',
      'Sausa': '120430',
      'Sincos': '120431',
      'Tunan Marca': '120432',
      'Yauli': '120433',
      'Yauyos': '120434',
    },
    Junín: {
      Junin: '120501',
      Carhuamayo: '120502',
      Ondores: '120503',
      Ulcumayo: '120504',
    },
    Satipo: {
      'Satipo': '120601',
      'Coviriali': '120602',
      'Llaylla': '120603',
      'Mazamari': '120604',
      'Pampa Hermosa': '120605',
      'Pangoa': '120606',
      'Río Negro': '120607',
      'Río Tambo': '120608',
      'Vizcatan del Ene': '120609',
    },
    Tarma: {
      'Tarma': '120701',
      'Acobamba': '120702',
      'Huaricolca': '120703',
      'Huasahuasi': '120704',
      'La Unión': '120705',
      'Palca': '120706',
      'Palcamayo': '120707',
      'San Pedro de Cajas': '120708',
      'Tapo': '120709',
    },
    Yauli: {
      'La Oroya': '120801',
      'Chacapalpa': '120802',
      'Huay-Huay': '120803',
      'Marcapomacocha': '120804',
      'Morococha': '120805',
      'Paccha': '120806',
      'Santa Bárbara de Carhuacayan': '120807',
      'Santa Rosa de Sacco': '120808',
      'Suitucancha': '120809',
      'Yauli': '120810',
    },
    Chupaca: {
      'Chupaca': '120901',
      'Ahuac': '120902',
      'Chongos Bajo': '120903',
      'Huachac': '120904',
      'Huamancaca Chico': '120905',
      'San Juan de Iscos': '120906',
      'San Juan de Jarpa': '120907',
      'Tres de Diciembre': '120908',
      'Yanacancha': '120909',
    },
  },
  'La Libertad': {
    'Trujillo': {
      'Trujillo': '130101',
      'El Porvenir': '130102',
      'Florencia de Mora': '130103',
      'Huanchaco': '130104',
      'La Esperanza': '130105',
      'Laredo': '130106',
      'Moche': '130107',
      'Poroto': '130108',
      'Salaverry': '130109',
      'Simbal': '130110',
      'Victor Larco Herrera': '130111',
    },
    'Ascope': {
      'Ascope': '130201',
      'Chicama': '130202',
      'Chocope': '130203',
      'Magdalena de Cao': '130204',
      'Paijan': '130205',
      'Rázuri': '130206',
      'Santiago de Cao': '130207',
      'Casa Grande': '130208',
    },
    'Bolívar': {
      Bolívar: '130301',
      Bambamarca: '130302',
      Condormarca: '130303',
      Longotea: '130304',
      Uchumarca: '130305',
      Ucuncha: '130306',
    },
    'Chepén': {
      'Chepen': '130401',
      'Pacanga': '130402',
      'Pueblo Nuevo': '130403',
    },
    'Julcán': {
      Julcan: '130501',
      Calamarca: '130502',
      Carabamba: '130503',
      Huaso: '130504',
    },
    'Otuzco': {
      'Otuzco': '130601',
      'Agallpampa': '130602',
      'Charat': '130604',
      'Huaranchal': '130605',
      'La Cuesta': '130606',
      'Mache': '130608',
      'Paranday': '130610',
      'Salpo': '130611',
      'Sinsicap': '130613',
      'Usquil': '130614',
    },
    'Pacasmayo': {
      'San Pedro de Lloc': '130701',
      'Guadalupe': '130702',
      'Jequetepeque': '130703',
      'Pacasmayo': '130704',
      'San José': '130705',
    },
    'Pataz': {
      'Tayabamba': '130801',
      'Buldibuyo': '130802',
      'Chillia': '130803',
      'Huancaspata': '130804',
      'Huaylillas': '130805',
      'Huayo': '130806',
      'Ongon': '130807',
      'Parcoy': '130808',
      'Pataz': '130809',
      'Pias': '130810',
      'Santiago de Challas': '130811',
      'Taurija': '130812',
      'Urpay': '130813',
    },
    'Sánchez Carrión': {
      Huamachuco: '130901',
      Chugay: '130902',
      Cochorco: '130903',
      Curgos: '130904',
      Marcabal: '130905',
      Sanagoran: '130906',
      Sarin: '130907',
      Sartimbamba: '130908',
    },
    'Santiago de Chuco': {
      'Santiago de Chuco': '131001',
      'Angasmarca': '131002',
      'Cachicadan': '131003',
      'Mollebamba': '131004',
      'Mollepata': '131005',
      'Quiruvilca': '131006',
      'Santa Cruz de Chuca': '131007',
      'Sitabamba': '131008',
    },
    'Gran Chimú': {
      Cascas: '131101',
      Lucma: '131102',
      Marmot: '131103',
      Sayapullo: '131104',
    },
    'Virú': { Viru: '131201', Chao: '131202', Guadalupito: '131203' },
  },
  'Lambayeque': {
    Chiclayo: {
      'Chiclayo': '140101',
      'Chongoyape': '140102',
      'Eten': '140103',
      'Eten Puerto': '140104',
      'José Leonardo Ortiz': '140105',
      'La Victoria': '140106',
      'Lagunas': '140107',
      'Monsefu': '140108',
      'Nueva Arica': '140109',
      'Oyotun': '140110',
      'Picsi': '140111',
      'Pimentel': '140112',
      'Reque': '140113',
      'Santa Rosa': '140114',
      'Saña': '140115',
      'Cayalti': '140116',
      'Patapo': '140117',
      'Pomalca': '140118',
      'Pucala': '140119',
      'Tuman': '140120',
    },
    Ferreñafe: {
      'Ferreñafe': '140201',
      'Cañaris': '140202',
      'Incahuasi': '140203',
      'Manuel Antonio Mesones Muro': '140204',
      'Pitipo': '140205',
      'Pueblo Nuevo': '140206',
    },
    Lambayeque: {
      'Lambayeque': '140301',
      'Chochope': '140302',
      'Illimo': '140303',
      'Jayanca': '140304',
      'Mochumi': '140305',
      'Morrope': '140306',
      'Motupe': '140307',
      'Olmos': '140308',
      'Pacora': '140309',
      'Salas': '140310',
      'San José': '140311',
      'Tucume': '140312',
    },
  },
  'Lima': {
    Lima: {
      'Lima': '150101',
      'Ancón': '150102',
      'Ate': '150103',
      'Barranco': '150104',
      'Breña': '150105',
      'Carabayllo': '150106',
      'Chaclacayo': '150107',
      'Chorrillos': '150108',
      'Cieneguilla': '150109',
      'Comas': '150110',
      'El Agustino': '150111',
      'Independencia': '150112',
      'Jesús María': '150113',
      'La Molina': '150114',
      'La Victoria': '150115',
      'Lince': '150116',
      'Los Olivos': '150117',
      'Lurigancho': '150118',
      'Lurin': '150119',
      'Magdalena del Mar': '150120',
      'Pueblo Libre': '150121',
      'Miraflores': '150122',
      'Pachacamac': '150123',
      'Pucusana': '150124',
      'Puente Piedra': '150125',
      'Punta Hermosa': '150126',
      'Punta Negra': '150127',
      'Rímac': '150128',
      'San Bartolo': '150129',
      'San Borja': '150130',
      'San Isidro': '150131',
      'San Juan de Lurigancho': '150132',
      'San Juan de Miraflores': '150133',
      'San Luis': '150134',
      'San Martín de Porres': '150135',
      'San Miguel': '150136',
      'Santa Anita': '150137',
      'Santa María del Mar': '150138',
      'Santa Rosa': '150139',
      'Santiago de Surco': '150140',
      'Surquillo': '150141',
      'Villa El Salvador': '150142',
      'Villa María del Triunfo': '150143',
    },
    Barranca: {
      'Barranca': '150201',
      'Paramonga': '150202',
      'Pativilca': '150203',
      'Supe': '150204',
      'Supe Puerto': '150205',
    },
    Cajatambo: {
      Cajatambo: '150301',
      Copa: '150302',
      Gorgor: '150303',
      Huancapon: '150304',
      Manas: '150305',
    },
    Canta: {
      'Canta': '150401',
      'Arahuay': '150402',
      'Huamantanga': '150403',
      'Huaros': '150404',
      'Lachaqui': '150405',
      'San Buenaventura': '150406',
      'Santa Rosa de Quives': '150407',
    },
    Cañete: {
      'San Vicente de Cañete': '150501',
      'Asia': '150502',
      'Calango': '150503',
      'Cerro Azul': '150504',
      'Chilca': '150505',
      'Coayllo': '150506',
      'Imperial': '150507',
      'Lunahuana': '150508',
      'Mala': '150509',
      'Nuevo Imperial': '150510',
      'Pacaran': '150511',
      'Quilmana': '150512',
      'San Antonio': '150513',
      'San Luis': '150514',
      'Santa Cruz de Flores': '150515',
      'Zúñiga': '150516',
    },
    Huaral: {
      'Huaral': '150601',
      'Atavillos Alto': '150602',
      'Atavillos Bajo': '150603',
      'Aucallama': '150604',
      'Chancay': '150605',
      'Ihuari': '150606',
      'Lampian': '150607',
      'Pacaraos': '150608',
      'San Miguel de Acos': '150609',
      'Santa Cruz de Andamarca': '150610',
      'Sumbilca': '150611',
      'Veintisiete de Noviembre': '150612',
    },
    Huarochirí: {
      'Matucana': '150701',
      'Antioquia': '150702',
      'Callahuanca': '150703',
      'Carampoma': '150704',
      'Chicla': '150705',
      'Cuenca': '150706',
      'Huachupampa': '150707',
      'Huanza': '150708',
      'Huarochiri': '150709',
      'Lahuaytambo': '150710',
      'Langa': '150711',
      'Laraos': '150712',
      'Mariatana': '150713',
      'Ricardo Palma': '150714',
      'San Andrés de Tupicocha': '150715',
      'San Antonio': '150716',
      'San Bartolomé': '150717',
      'San Damian': '150718',
      'San Juan de Iris': '150719',
      'San Juan de Tantaranche': '150720',
      'San Lorenzo de Quinti': '150721',
      'San Mateo': '150722',
      'San Mateo de Otao': '150723',
      'San Pedro de Casta': '150724',
      'San Pedro de Huancayre': '150725',
      'Sangallaya': '150726',
      'Santa Cruz de Cocachacra': '150727',
      'Santa Eulalia': '150728',
      'Santiago de Anchucaya': '150729',
      'Santiago de Tuna': '150730',
      'Santo Domingo de Los Olleros': '150731',
      'Surco': '150732',
    },
    Huaura: {
      'Huacho': '150801',
      'Ambar': '150802',
      'Caleta de Carquin': '150803',
      'Checras': '150804',
      'Hualmay': '150805',
      'Huaura': '150806',
      'Leoncio Prado': '150807',
      'Paccho': '150808',
      'Santa Leonor': '150809',
      'Santa María': '150810',
      'Sayan': '150811',
      'Vegueta': '150812',
    },
    Oyón: {
      Oyon: '150901',
      Andajes: '150902',
      Caujul: '150903',
      Cochamarca: '150904',
      Navan: '150905',
      Pachangara: '150906',
    },
    Yauyos: {
      'Yauyos': '151001',
      'Alis': '151002',
      'Allauca': '151003',
      'Ayaviri': '151004',
      'Azángaro': '151005',
      'Cacra': '151006',
      'Carania': '151007',
      'Catahuasi': '151008',
      'Chocos': '151009',
      'Cochas': '151010',
      'Colonia': '151011',
      'Hongos': '151012',
      'Huampara': '151013',
      'Huancaya': '151014',
      'Huangascar': '151015',
      'Huantan': '151016',
      'Huañec': '151017',
      'Laraos': '151018',
      'Lincha': '151019',
      'Madean': '151020',
      'Miraflores': '151021',
      'Omas': '151022',
      'Putinza': '151023',
      'Quinches': '151024',
      'Quinocay': '151025',
      'San Joaquín': '151026',
      'San Pedro de Pilas': '151027',
      'Tanta': '151028',
      'Tauripampa': '151029',
      'Tomas': '151030',
      'Tupe': '151031',
      'Viñac': '151032',
      'Vitis': '151033',
    },
  },
  'Loreto': {
    'Maynas': {
      'Iquitos': '160101',
      'Alto Nanay': '160102',
      'Fernando Lores': '160103',
      'Indiana': '160104',
      'Las Amazonas': '160105',
      'Mazan': '160106',
      'Napo': '160107',
      'Punchana': '160108',
      'Torres Causana': '160110',
      'Belén': '160112',
      'San Juan Bautista': '160113',
    },
    'Alto Amazonas': {
      'Yurimaguas': '160201',
      'Balsapuerto': '160202',
      'Jeberos': '160205',
      'Lagunas': '160206',
      'Santa Cruz': '160210',
      'Teniente Cesar López Rojas': '160211',
    },
    'Loreto': {
      Nauta: '160301',
      Parinari: '160302',
      Tigre: '160303',
      Trompeteros: '160304',
      Urarinas: '160305',
    },
    'Mariscal Ramón Castilla': {
      'Ramón Castilla': '160401',
      'Pebas': '160402',
      'Yavari': '160403',
      'San Pablo': '160404',
    },
    'Requena': {
      'Requena': '160501',
      'Alto Tapiche': '160502',
      'Capelo': '160503',
      'Emilio San Martín': '160504',
      'Maquia': '160505',
      'Puinahua': '160506',
      'Saquena': '160507',
      'Soplin': '160508',
      'Tapiche': '160509',
      'Jenaro Herrera': '160510',
      'Yaquerana': '160511',
    },
    'Ucayali': {
      'Contamana': '160601',
      'Inahuaya': '160602',
      'Padre Márquez': '160603',
      'Pampa Hermosa': '160604',
      'Sarayacu': '160605',
      'Vargas Guerra': '160606',
    },
    'Datem del Marañón': {
      Barranca: '160701',
      Cahuapanas: '160702',
      Manseriche: '160703',
      Morona: '160704',
      Pastaza: '160705',
      Andoas: '160706',
    },
    'Putumayo': {
      'Putumayo': '160801',
      'Rosa Panduro': '160802',
      'Teniente Manuel Clavero': '160803',
      'Yaguas': '160804',
    },
  },
  'Madre de Dios': {
    Tambopata: {
      'Tambopata': '170101',
      'Inambari': '170102',
      'Las Piedras': '170103',
      'Laberinto': '170104',
    },
    Manu: {
      'Manu': '170201',
      'Fitzcarrald': '170202',
      'Madre de Dios': '170203',
      'Huepetuhe': '170204',
    },
    Tahuamanu: {
      Iñapari: '170301',
      Iberia: '170302',
      Tahuamanu: '170303',
    },
  },
  'Moquegua': {
    'Mariscal Nieto': {
      'Moquegua': '180101',
      'Carumas': '180102',
      'Cuchumbaya': '180103',
      'Samegua': '180104',
      'San Cristóbal': '180105',
      'Torata': '180106',
    },
    'General Sánchez Cerro': {
      'Omate': '180201',
      'Chojata': '180202',
      'Coalaque': '180203',
      'Ichuña': '180204',
      'La Capilla': '180205',
      'Lloque': '180206',
      'Matalaque': '180207',
      'Puquina': '180208',
      'Quinistaquillas': '180209',
      'Ubinas': '180210',
      'Yunga': '180211',
    },
    'Ilo': { 'Ilo': '180301', 'El Algarrobal': '180302', 'Pacocha': '180303' },
  },
  'Pasco': {
    'Pasco': {
      'Chaupimarca': '190101',
      'Huachon': '190102',
      'Huariaca': '190103',
      'Huayllay': '190104',
      'Ninacaca': '190105',
      'Pallanchacra': '190106',
      'Paucartambo': '190107',
      'San Francisco de Asís de Yarusyacan': '190108',
      'Simon Bolívar': '190109',
      'Ticlacayan': '190110',
      'Tinyahuarco': '190111',
      'Vicco': '190112',
      'Yanacancha': '190113',
    },
    'Daniel Alcides Carrión': {
      'Yanahuanca': '190201',
      'Chacayan': '190202',
      'Goyllarisquizga': '190203',
      'Paucar': '190204',
      'San Pedro de Pillao': '190205',
      'Santa Ana de Tusi': '190206',
      'Tapuc': '190207',
      'Vilcabamba': '190208',
    },
    'Oxapampa': {
      'Oxapampa': '190301',
      'Chontabamba': '190302',
      'Huancabamba': '190303',
      'Palcazu': '190304',
      'Pozuzo': '190305',
      'Puerto Bermúdez': '190306',
      'Villa Rica': '190307',
      'Constitución': '190308',
    },
  },
  'Piura': {
    Piura: {
      'Piura': '200101',
      'Castilla': '200104',
      'Catacaos': '200105',
      'Cura Mori': '200107',
      'El Tallan': '200108',
      'La Arena': '200109',
      'La Unión': '200110',
      'Las Lomas': '200111',
      'Tambo Grande': '200114',
      'Veintiseis de Octubre': '200115',
    },
    Ayabaca: {
      Ayabaca: '200201',
      Frias: '200202',
      Jilili: '200203',
      Lagunas: '200204',
      Montero: '200205',
      Pacaipampa: '200206',
      Paimas: '200207',
      Sapillica: '200208',
      Sicchez: '200209',
      Suyo: '200210',
    },
    Huancabamba: {
      'Huancabamba': '200301',
      'Canchaque': '200302',
      'El Carmen de la Frontera': '200303',
      'Huarmaca': '200304',
      'Lalaquiz': '200305',
      'San Miguel de El Faique': '200306',
      'Sondor': '200307',
      'Sondorillo': '200308',
    },
    Morropón: {
      'Chulucanas': '200401',
      'Buenos Aires': '200402',
      'Chalaco': '200403',
      'La Matanza': '200404',
      'Morropon': '200405',
      'Salitral': '200406',
      'San Juan de Bigote': '200407',
      'Santa Catalina de Mossa': '200408',
      'Santo Domingo': '200409',
      'Yamango': '200410',
    },
    Paita: {
      'Paita': '200501',
      'Amotape': '200502',
      'Arenal': '200503',
      'Colan': '200504',
      'La Huaca': '200505',
      'Tamarindo': '200506',
      'Vichayal': '200507',
    },
    Sullana: {
      'Sullana': '200601',
      'Bellavista': '200602',
      'Ignacio Escudero': '200603',
      'Lancones': '200604',
      'Marcavelica': '200605',
      'Miguel Checa': '200606',
      'Querecotillo': '200607',
      'Salitral': '200608',
    },
    Talara: {
      'Pariñas': '200701',
      'El Alto': '200702',
      'La Brea': '200703',
      'Lobitos': '200704',
      'Los Organos': '200705',
      'Mancora': '200706',
    },
    Sechura: {
      'Sechura': '200801',
      'Bellavista de la Unión': '200802',
      'Bernal': '200803',
      'Cristo Nos Valga': '200804',
      'Vice': '200805',
      'Rinconada Llicuar': '200806',
    },
  },
  'Puno': {
    'Puno': {
      'Puno': '210101',
      'Acora': '210102',
      'Amantani': '210103',
      'Atuncolla': '210104',
      'Capachica': '210105',
      'Chucuito': '210106',
      'Coata': '210107',
      'Huata': '210108',
      'Mañazo': '210109',
      'Paucarcolla': '210110',
      'Pichacani': '210111',
      'Plateria': '210112',
      'San Antonio': '210113',
      'Tiquillaca': '210114',
      'Vilque': '210115',
    },
    'Azángaro': {
      'Azángaro': '210201',
      'Achaya': '210202',
      'Arapa': '210203',
      'Asillo': '210204',
      'Caminaca': '210205',
      'Chupa': '210206',
      'José Domingo Choquehuanca': '210207',
      'Muñani': '210208',
      'Potoni': '210209',
      'Saman': '210210',
      'San Anton': '210211',
      'San José': '210212',
      'San Juan de Salinas': '210213',
      'Santiago de Pupuja': '210214',
      'Tirapata': '210215',
    },
    'Carabaya': {
      'Macusani': '210301',
      'Ajoyani': '210302',
      'Ayapata': '210303',
      'Coasa': '210304',
      'Corani': '210305',
      'Crucero': '210306',
      'Ituata': '210307',
      'Ollachea': '210308',
      'San Gaban': '210309',
      'Usicayos': '210310',
    },
    'Chucuito': {
      Juli: '210401',
      Desaguadero: '210402',
      Huacullani: '210403',
      Kelluyo: '210404',
      Pisacoma: '210405',
      Pomata: '210406',
      Zepita: '210407',
    },
    'El Collao': {
      'Ilave': '210501',
      'Capazo': '210502',
      'Pilcuyo': '210503',
      'Santa Rosa': '210504',
      'Conduriri': '210505',
    },
    'Huancané': {
      'Huancane': '210601',
      'Cojata': '210602',
      'Huatasani': '210603',
      'Inchupalla': '210604',
      'Pusi': '210605',
      'Rosaspata': '210606',
      'Taraco': '210607',
      'Vilque Chico': '210608',
    },
    'Lampa': {
      'Lampa': '210701',
      'Cabanilla': '210702',
      'Calapuja': '210703',
      'Nicasio': '210704',
      'Ocuviri': '210705',
      'Palca': '210706',
      'Paratia': '210707',
      'Pucara': '210708',
      'Santa Lucia': '210709',
      'Vilavila': '210710',
    },
    'Melgar': {
      'Ayaviri': '210801',
      'Antauta': '210802',
      'Cupi': '210803',
      'Llalli': '210804',
      'Macari': '210805',
      'Nuñoa': '210806',
      'Orurillo': '210807',
      'Santa Rosa': '210808',
      'Umachiri': '210809',
    },
    'Moho': {
      Moho: '210901',
      Conima: '210902',
      Huayrapata: '210903',
      Tilali: '210904',
    },
    'San Antonio de Putina': {
      'Putina': '211001',
      'Ananea': '211002',
      'Pedro Vilca Apaza': '211003',
      'Quilcapuncu': '211004',
      'Sina': '211005',
    },
    'San Román': {
      'Juliaca': '211101',
      'Cabana': '211102',
      'Cabanillas': '211103',
      'Caracoto': '211104',
      'San Miguel': '211105',
    },
    'Sandia': {
      'Sandia': '211201',
      'Cuyocuyo': '211202',
      'Limbani': '211203',
      'Patambuco': '211204',
      'Phara': '211205',
      'Quiaca': '211206',
      'San Juan del Oro': '211207',
      'Yanahuaya': '211208',
      'Alto Inambari': '211209',
      'San Pedro de Putina Punco': '211210',
    },
    'Yunguyo': {
      Yunguyo: '211301',
      Anapia: '211302',
      Copani: '211303',
      Cuturapi: '211304',
      Ollaraya: '211305',
      Tinicachi: '211306',
      Unicachi: '211307',
    },
  },
  'San Martín': {
    'Moyobamba': {
      Moyobamba: '220101',
      Calzada: '220102',
      Habana: '220103',
      Jepelacio: '220104',
      Soritor: '220105',
      Yantalo: '220106',
    },
    'Bellavista': {
      'Bellavista': '220201',
      'Alto Biavo': '220202',
      'Bajo Biavo': '220203',
      'Huallaga': '220204',
      'San Pablo': '220205',
      'San Rafael': '220206',
    },
    'El Dorado': {
      'San José de Sisa': '220301',
      'Agua Blanca': '220302',
      'San Martín': '220303',
      'Santa Rosa': '220304',
      'Shatoja': '220305',
    },
    'Huallaga': {
      'Saposoa': '220401',
      'Alto Saposoa': '220402',
      'El Eslabón': '220403',
      'Piscoyacu': '220404',
      'Sacanche': '220405',
      'Tingo de Saposoa': '220406',
    },
    'Lamas': {
      'Lamas': '220501',
      'Alonso de Alvarado': '220502',
      'Barranquita': '220503',
      'Caynarachi': '220504',
      'Cuñumbuqui': '220505',
      'Pinto Recodo': '220506',
      'Rumisapa': '220507',
      'San Roque de Cumbaza': '220508',
      'Shanao': '220509',
      'Tabalosos': '220510',
      'Zapatero': '220511',
    },
    'Mariscal Cáceres': {
      Juanjuí: '220601',
      Campanilla: '220602',
      Huicungo: '220603',
      Pachiza: '220604',
      Pajarillo: '220605',
    },
    'Picota': {
      'Picota': '220701',
      'Buenos Aires': '220702',
      'Caspisapa': '220703',
      'Pilluana': '220704',
      'Pucacaca': '220705',
      'San Cristóbal': '220706',
      'San Hilarión': '220707',
      'Shamboyacu': '220708',
      'Tingo de Ponasa': '220709',
      'Tres Unidos': '220710',
    },
    'Rioja': {
      'Rioja': '220801',
      'Awajun': '220802',
      'Elías Soplin Vargas': '220803',
      'Nueva Cajamarca': '220804',
      'Pardo Miguel': '220805',
      'Posic': '220806',
      'San Fernando': '220807',
      'Yorongos': '220808',
      'Yuracyacu': '220809',
    },
    'San Martín': {
      'Tarapoto': '220901',
      'Alberto Leveau': '220902',
      'Cacatachi': '220903',
      'Chazuta': '220904',
      'Chipurana': '220905',
      'El Porvenir': '220906',
      'Huimbayoc': '220907',
      'Juan Guerra': '220908',
      'La Banda de Shilcayo': '220909',
      'Morales': '220910',
      'Papaplaya': '220911',
      'San Antonio': '220912',
      'Sauce': '220913',
      'Shapaja': '220914',
    },
    'Tocache': {
      'Tocache': '221001',
      'Nuevo Progreso': '221002',
      'Polvora': '221003',
      'Shunte': '221004',
      'Uchiza': '221005',
    },
  },
  'Tacna': {
    'Tacna': {
      'Tacna': '230101',
      'Alto de la Alianza': '230102',
      'Calana': '230103',
      'Ciudad Nueva': '230104',
      'Inclan': '230105',
      'Pachia': '230106',
      'Palca': '230107',
      'Pocollay': '230108',
      'Sama': '230109',
      'Coronel Gregorio Albarracín Lanchipa': '230110',
      'La Yarada los Palos': '230111',
    },
    'Candarave': {
      Candarave: '230201',
      Cairani: '230202',
      Camilaca: '230203',
      Curibaya: '230204',
      Huanuara: '230205',
      Quilahuani: '230206',
    },
    'Jorge Basadre': {
      Locumba: '230301',
      Ilabaya: '230302',
      Ite: '230303',
    },
    'Tarata': {
      'Tarata': '230401',
      'Héroes Albarracín': '230402',
      'Estique': '230403',
      'Estique-Pampa': '230404',
      'Sitajara': '230405',
      'Susapaya': '230406',
      'Tarucachi': '230407',
      'Ticaco': '230408',
    },
  },
  'Tumbes': {
    'Tumbes': {
      'Tumbes': '240101',
      'Corrales': '240102',
      'La Cruz': '240103',
      'Pampas de Hospital': '240104',
      'San Jacinto': '240105',
      'San Juan de la Virgen': '240106',
    },
    'Contralmirante Villar': {
      'Zorritos': '240201',
      'Casitas': '240202',
      'Canoas de Punta Sal': '240203',
    },
    'Zarumilla': {
      'Zarumilla': '240301',
      'Aguas Verdes': '240302',
      'Matapalo': '240303',
      'Papayal': '240304',
    },
  },
  'Ucayali': {
    'Coronel Portillo': {
      'Calleria': '250101',
      'Campoverde': '250102',
      'Iparia': '250103',
      'Masisea': '250104',
      'Yarinacocha': '250105',
      'Nueva Requena': '250106',
      'Manantay': '250107',
    },
    'Atalaya': {
      Raymondi: '250201',
      Sepahua: '250202',
      Tahuania: '250203',
      Yurua: '250204',
    },
    'Padre Abad': {
      'Padre Abad': '250301',
      'Irazola': '250302',
      'Curimana': '250303',
      'Neshuya': '250304',
      'Alexander Von Humboldt': '250305',
    },
    'Purús': { Purus: '250401' },
  },
};
